import React, { FC } from 'react';
import { useTranslations } from '../../../../../hooks/useTranslationsHelper';
import { ParsedPromo } from '../../types';

interface CardCTASectionProps {
  onClaimClick?: () => void;
  onViewDetailsClick?: () => void;
  showPrimary?: boolean;
  showSecondary?: boolean;
  promo: ParsedPromo;
  isActivePromotions?: boolean;
}

export const CardCTASection: FC<CardCTASectionProps> = ({
  onClaimClick,
  onViewDetailsClick,
  showPrimary = true,
  showSecondary = true,
  isActivePromotions,
  promo,
}): JSX.Element | null => {
  const { t } = useTranslations();

  const primaryCTAText = isActivePromotions
    ? promo.ctaCopy || t('promotions.button.active-cta.text')
    : t('promotions.button.opt-in.text');

  const showSecondaryButton = showSecondary;

  const handleClaimClick = (e: React.MouseEvent): void => {
    e.stopPropagation();
    onClaimClick?.();
  };

  const handleViewDetailsClick = (e: React.MouseEvent): void => {
    e.stopPropagation();
    onViewDetailsClick?.();
  };

  return (
    <div className="promotion-card__cta-section">
      <div className="promotion-card__buttons">
        {showPrimary && (
          <button className="promotion-card__btn promotion-card__btn--primary" onClick={handleClaimClick}>
            {primaryCTAText}
          </button>
        )}

        {showSecondaryButton && (
          <button className="promotion-card__btn promotion-card__btn--secondary" onClick={handleViewDetailsClick}>
            {t('promotions.button.view-detail.text')}
          </button>
        )}
      </div>
    </div>
  );
};
